import { compose } from 'recompose';

import { withTranslation } from 'react-i18next';

import Feedback from 'components/Feedback/component';

const enhance = compose(withTranslation('Feedback'));

export default enhance(Feedback);
